import { postApi } from "../api/api";
import { encryptFunction } from "../components/popencrypt2.2v1/encryptfunction";
import { xMerckApiKey } from "../constants/env";
import { getSessionId, getUserId, fetchToken, setTokenToStorage, getStoredToken, generateTokenDataString, generateTokenRequest  } from "./tokenService";


export const loginApi = async (auth_string, data_string) => {

    let tokenData = getStoredToken(), token;
    if(tokenData) {
        if (new Date(tokenData.storedExpiry) - new Date() <= 0) {
            // ToDo: navigate to login
            console.log('expired');
            return {data : {RESPONSE_STATUS_CD: 'EXPIRED'}};
        } else {
            token = tokenData.storedToken;
        }
    }
    if(!token) {
        const dataString = encryptFunction(generateTokenDataString());
        const authString = encryptFunction(generateTokenRequest());
        const resp = await fetchToken(authString, dataString);
        token = resp.data.DATA.TOKEN;
        setTokenToStorage(token, resp.data.DATA.EXPIRY);
    }

    return await postApi('/qoldecrypt', 
        {
            AUTH_STRING: auth_string,
            DATA_STRING: data_string
        }, 
        {
            userId: getUserId(),
            sessionId: getSessionId(),
            'X-Merck-APIKey': xMerckApiKey,
            token: token
            //'Access-Control-Allow-Origin': '*'
           // 'x-apigw-api-id': 'phn78ucyjg'
        });
}
